import { io } from "socket.io-client";

const socket = io("https://admin.kwicpe.com", {
  path: "/api/socket.io",
  transports: ["websocket", "polling"],
  // transports: ["polling"], 
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 1000,
});

socket.onAny((event, ...args) => {
  console.log("RAW socket event:", event, args);
});

socket.on("connect", () => console.log("SOCKET CONNECTED:", socket.id));
socket.on("disconnect", (r) => console.log("SOCKET DISCONNECTED:", r));
socket.on("connect_error", (e) => console.log("SOCKET CONNECT_ERROR:", e?.message));
socket.io.on("reconnect_attempt", () => console.log("SOCKET RECONNECTING..."));
socket.onAny((event) => console.log("SOCKET EVENT:", event));

export default socket;